module.exports = __webpack_public_path__ + "media/images/taxigo-platinum/bg-img-e9e3eceac42dd352c798a618a8eb8af4.png";